// extracted by mini-css-extract-plugin
module.exports = {"sizeChartSkeleton":"styles_sizeChartSkeleton__PPcIY","tableLine":"styles_tableLine__9Jsd2","tableCell":"styles_tableCell___JLCv"};